<template>
  <div class="slide6">
    <div class="text-box">판.매.수.수.료</div>
    <div class="text-box">앱.내.외.홍.보</div>
    <div class="text-box">라.이.브.방.송</div>
    <div class="text-point">0%</div>
    <div class="text-description">
      입점사와 함께 성장하기 위해 ON STYLE LIVE에 입점하는 모든 입점사는
      <br />판매수수료,앱내외홍보비용,라이브방송비용 모두 무료입니다.
    </div>
  </div>
</template>
<script>
export default {
  name: "Slide6"
};
</script>
<style lang="scss" scoped>
.slide6 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: 50px 50px;
  background-image: repeating-radial-gradient(
    white 0px,
    #f5f0e7 2px,
    #f5f0e7 48px
  );
  padding: 100px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;
  position: relative;

  .text-box {
    font-size: 8vh;
    font-weight: 600;
    color: mix(#aca599, #948e82, 85%);
    letter-spacing: 15px;
    margin-bottom: 50px;
    // text-shadow:
    //     -0.0075em 0.0075em 0 mix(#aca599, #948e82, 94%),
    //     0.005em 0.005em 0 mix(#aca599, #948e82, 60%),
    //     0.01em 0.01em 0 mix(#aca599, #948e82, 62%),
    //     0.015em 0.015em mix(#aca599, #948e82, 64%),
    //     0.02em 0.02em 0 mix(#aca599, #948e82, 66%),
    //     0.025em 0.025em 0 mix(#aca599, #948e82, 68%),
    //     0.03em 0.03em 0 mix(#aca599, #948e82, 70%),
    //     0.035em 0.035em 0 mix(#aca599, #948e82, 72%);
  }
  .text-point {
    font-size: 15vh;
    font-weight: 900;
    color: #ff5c5c;
    margin-bottom: 30px;
  }
  .text-description {
    font-size: 2vh;
    color: #948e82;
  }
}
</style>